import styles from "./GroupBox.css.ts";

/**
 * Renders a GroupBox component that displays a headline and child elements.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.headline - The headline text to be displayed inside the group box.
 * @param {React.ReactNode} props.children - The child elements to be rendered inside the group box.
 * @param {boolean} [props.highlighted=false] - Indicates if the group box is associated with participating teachers.
 * @return {JSX.Element} A section element containing the headline and child components.
 */
function GroupBox({ headline, children, highlighted = false }) {
  return (
    <section
      className={styles.container({
        highlighted: highlighted,
      })}
    >
      <h3 className={styles.headline}>{headline}</h3>
      {children}
    </section>
  );
}

export default GroupBox;
